var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompaniesDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Rahmen",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 106",
    style: {
      enableBackground: "new 0 0 110 106"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#B4CCDD;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35,21v44h40V21H35z M73,63H37V23h36V63z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "65.6,32 65.6,30.1 62.2,30.1 62.2,32 61.8,45.1 61.8,45.1 61.7,46.9 66.1,46.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.3,47.4v-4.8l-8.7,4.8v-4.8L42,47.4V58h5.6h0.6h3v-4h8v4h2.4h1H68V42.6L59.3,47.4z M49.4,52.2H46h-1.6v-3.8 h4.1h0.9V52.2z M57.6,52.2h-3.4h-1.6v-3.8h4.1h0.9V52.2z M65.7,52.2h-3.4h-1.6v-3.8h4.1h0.9V52.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompaniesDefault);
export default __webpack_public_path__ + "static/media/companies-default.d2c15b83c4d2b12139a4deef3a8893a2.svg";
export { ForwardRef as ReactComponent };